<template>
  <div :ref="chartRefId" style="width: 100%; height: 260px;"></div>
</template>

<script>
import * as echarts from 'echarts';

export default {
  name: 'BarChartGroupedECharts',
  props: {
    months: { type: Array, required: true },
    lastYear: { type: Array, required: true },
    present: { type: Array, required: true }
  },
  data() {
    return {
      chartRefId: `bar-grouped-${this._uid}`,
      chartInstance: null
    };
  },
  mounted() {
    this.initChart();
    window.addEventListener('resize', this.resizeChart);
  },
  watch: {
    months() {
      this.updateChart();
    },
    lastYear() {
      this.updateChart();
    },
    present() {
      this.updateChart();
    }
  },
  methods: {
    initChart() {
      const el = this.$refs[this.chartRefId];
      if (!el) return;

      this.chartInstance = echarts.init(el);

      this.chartInstance.setOption({
        tooltip: {
          trigger: 'axis',
          axisPointer: { type: 'shadow' }
        },
        grid: {
          left: '3%',
          right: '3%',
          bottom: '10%',
          containLabel: true
        },
        xAxis: {
          type: 'category',
          data: this.months
        },
        yAxis: {
          type: 'value',
          max: 100,
          interval: 25,
          axisLabel: {
            formatter: '{value}%'
          },
          splitLine: {
            show: false
          }
        },
        series: [
          {
            name: 'Last Year',
            type: 'bar',
            data: this.lastYear,
            barGap: '10%',
            itemStyle: { color: '#FDE68A' }
          },
          {
            name: 'Present',
            type: 'bar',
            data: this.present,
            itemStyle: { color: '#F59E0B' }
          }
        ]
      });
    },
    updateChart() {
      if (!this.chartInstance) return;
      this.chartInstance.setOption({
        xAxis: {
          type: 'category',
          data: this.months
        },
        series: [
          {
            name: 'Last Year',
            type: 'bar',
            data: this.lastYear,
            barGap: '10%',
            itemStyle: { color: '#FDE68A' }
          },
          {
            name: 'Present',
            type: 'bar',
            data: this.present,
            itemStyle: { color: '#F59E0B' }
          }
        ]
      });
    },
    resizeChart() {
        if (this.chartInstance) {
            this.chartInstance.resize();
        }
    },
  },
  beforeUnmount() {
    window.removeEventListener('resize', this.resizeChart);
    if (this.chartInstance) {
        this.chartInstance.dispose();
    }
  }
};
</script>
